module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/bridge_image_01-88d73a114e2d80e24bef539b249aa78a.png";